<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <!--  <parallax
        class="page-header-image"
        style="background-image:url('img/dashboard.jpg');"
      >
      </parallax> -->
      <video autoplay muted loop playsinline class="hero-bg-video">
        <source :src="someVidio" type="video/mp4" />
        <source src="vido_tef.ogg" type="video/ogg" />
        {{ $t("landingPage.videoNotSupported") }}
      </video>
      <div class="motoWeare">
        <div class="container">
          <div class="pioneer-card animated fadeInDown">
            <h1 class="pioneer-card-title" v-html="$t('landingPage.pioneers.title')"></h1>
            <p class="pioneer-card-desc" v-html="$t('landingPage.pioneers.description')"></p>
            <router-link to="/about-us" class="pioneer-readmore-btn">
              <span>{{ $t('common.offices.readMore') }}</span>
              <span class="pioneer-readmore-icon"><i class="fa fa-arrow-right"></i></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card stats-card-wrap">
      <div class="row text-center stats-bar">
        <div class="col-lg-3 col-6 stat-item">
          <i class="fa fa-industry stat-icon"></i>
          <h4>
            <span
              class="years-number counter"
              style="--animation: counter-years"
            ></span>
            <br />
            <b>{{ $t("landingPage.counters.project") }}</b>
          </h4>
        </div>
        <div class="col-lg-3 col-6 stat-item">
          <i class="fa fa-globe stat-icon"></i>
          <h4>
            <span
              class="project-number counter"
              style="--animation: counter-projects"
            ></span>
            <br />
            <b>{{ $t("landingPage.counters.countriesExport") }}</b>
          </h4>
        </div>
        <div class="col-lg-3 col-6 stat-item">
          <i class="fa fa-flask stat-icon"></i>
          <h4>
            <span
              class="employee-number counter"
              style="--animation: counter-employees"
            ></span>
            <br />
            <b>{{ $t("landingPage.counters.typeOfMaterials") }}</b>
          </h4>
        </div>
        <div class="col-lg-3 col-6 stat-item">
          <i class="fa fa-users stat-icon"></i>
          <h4>
            <span
              class="customers-number counter"
              style="--animation: counter-customers"
            ></span>
            <br />
            <b>{{ $t("landingPage.counters.customers") }}</b>
          </h4>
        </div>
      </div>
    </div>

    <!-- <marquee style="font-weight: bold; margin-top: 0px;">
      <hr style="border: 1px solid red;">
      TEF has been focusing fabrication of stainless steel or higher grade materials, such as Ni base alloys materials, Titanium etc., well known as exotic materials.
      <hr style="border: 1px solid red;"> 
    </marquee> -->
    <!-- OUR KEY TECHNOLOGY -->
    <div class="section mb-n5">
      <div class="container">
        <div class="container" style="border-radius: 2%">
          <h2 class="font-weight-bold mt-4" style="color: #008c45">
            <img
              src="img/icon/icon (50).png"
              alt=""
              width="6%"
              class="ml-3 mr-3"
            />
            {{ $t("landingPage.oneStopSolutions.title") }}
          </h2>
          <h5>{{ $t("landingPage.oneStopSolutions.description") }}</h5>
          <div class="row mt-4 align-items-stretch">
            <div class="col-lg-6 mb-4 d-flex">
              <div
                class="card reveal-up solution-card w-100 text-white"
                style="background: #008c45"
              >
                <img
                  src="img/prod.jpeg"
                  :alt="$t('landingPage.oneStopSolutions.fabrication.title')"
                  class="solution-card-img"
                />
                <div class="solution-card-body">
                  <h5 class="font-weight-bold solution-card-title">
                    {{ $t("landingPage.oneStopSolutions.fabrication.title") }}
                  </h5>
                  <p class="solution-card-desc">
                    {{
                      $t("landingPage.oneStopSolutions.fabrication.description")
                    }}
                  </p>
                  <router-link to="/service" class="solution-readmore-link">
                    <span class="solution-readmore"
                      >{{
                        $t("landingPage.oneStopSolutions.fabrication.readMore")
                      }}
                      <i class="fa fa-arrow-right ml-1"></i
                    ></span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-4 d-flex">
              <div
                class="card reveal-up solution-card w-100 text-white"
                style="background: #008c45"
              >
                <img
                  src="img/detail_product/service/Retubing/04_Removing Weld.jpeg"
                  :alt="$t('landingPage.oneStopSolutions.reconditioning.title')"
                  class="solution-card-img"
                />
                <div class="solution-card-body">
                  <h5 class="font-weight-bold solution-card-title">
                    {{
                      $t("landingPage.oneStopSolutions.reconditioning.title")
                    }}
                  </h5>
                  <p class="solution-card-desc">
                    {{
                      $t(
                        "landingPage.oneStopSolutions.reconditioning.description",
                      )
                    }}
                  </p>
                  <router-link to="/service" class="solution-readmore-link">
                    <span class="solution-readmore"
                      >{{
                        $t(
                          "landingPage.oneStopSolutions.reconditioning.readMore",
                        )
                      }}
                      <i class="fa fa-arrow-right ml-1"></i
                    ></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <!-- CARD INTRODUCTION -->
        <!-- <div class="row" style="margin-top: 230px; margin-bottom: 100px;">
          <div class="col-md-10 col-xl-4 mt-6 text-left" style="margin-right= 800px;">
            <img
              src="img/yunomae.png"
              class="img-fluid rounded animated fadeInDown"
              style="margin-top: 130px;"
            /><br>
            President Director <br>
            Mr. Ryohichi Yunomae <br>
            湯之前 良一 <br>
          </div>
          <div class="col-md-10 ml-auto col-xl-8 mr-auto " style="margin-top: 140px;">
            <h3 class="font-weight-bold align-middle mt-5">
                <span style="color: #008c45;">PT TOKKI ENGINEERING AND FABRICATION</span>
                </h3> 
                Is providing quality products and good after-sales technical service from the Tropical Island in Indonesia to all over the world.  We are the specialized Company in the welded pressure vessels and sheet metal combining of industrial infrastructure Including Oil & Gas, Petrochemicals, Pharmaceuticals, Fertilizer, Agricultural chemicals, Power Plant and Thermal Processing industries.
                We show the spirit of challenge based on the differential advantage of "Engineering Capability“, “Consulting”, “Workmanship (Proficiency in Welding)”, “Special Materials”, research and develop, manufacture, and sell our products which make our Customers satisfied.
                We believe our Company owes its prosperity to the strong and kind support of our Customers, people working with us, and local citizens. We would like to ask for your continued support and guidance.
          </div>
        </div> -->

        <!-- SECOND INTRODUCTION -->
        <!-- <div style="color: red:">
          <img
            src="img/home1.png"
            class=" img-fluid  mt-4"/>
        </div> -->
        <!-- <div style="color: red;" class="mt-5">
          <img
            src="img/home3.png"
            class=" img-fluid  mt-4"/>
        </div> -->

        <!-- <div class="section-story-overview mt-5">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left mb-5"
                style="background-image: url('img/home5.png')"
              >
                <p class="blockquote blockquote-primary">
                  "Over the span of the satellite record, Arctic sea ice has
                  been declining significantly, while sea ice in the
                  Antarctichas increased very slightly"
                  <br />
                  <br />
                  <small>-NOAA</small>
                </p>
              </div>
              <div
                class="mb-5"
              ></div><br><br>
              <img
                src="img/home6.png"
                class=" img-fluid  mt-5"/>
            </div>
            <div class="col-md-5">
              <div
                class="image-container image-right"
                style="background-image: url('img/home4.png')"
              ></div>
              <h3>
                Navigating the Future “Mastery Meets Innovation”
              </h3>
              <p>
                If there is any corrosion issues, leave it to TEF.
TEF contributes to safe and secure plant operations.
              </p>
              <p>
                We will contribute to improving
the production efficiency and reliability of process industries
              </p>
              <p>
                We provide total support for corrosion challenges in the process industries. From selecting the optimal
materials and cost-effective designs to high-quality fabrication and maintenance, we ensure the reliability
of your process equipment, pressure vessels, and piping.
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- GALERY OF WORK -->
    <div class="section section-tabs mt-n5 mb-n5">
      <div class="container mt-n5">
        <div class="row">
          <div class="col-md-6 ml-auto mr-auto">
            <h4 class="title text-center">
              {{ $t("landingPage.gallery.title") }}
            </h4>
          </div>
          <tabs
            pills
            class="nav-align-center"
            tab-content-classes="gallery"
            tab-nav-classes="nav-pills-just-icons"
            type="success"
          >
            <tab-pane :title="$t('landingPage.gallery.tabs.machine')">
              <i slot="label" class="now-ui-icons loader_gear"></i>
              <div class="col-md-10 ml-auto mr-auto">
                <div class="row collections">
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/facility/machine_hydraulic.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/IMG_1315.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/facility/crane.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/IMG_0820.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane :title="$t('landingPage.gallery.tabs.area')">
              <i slot="label" class="now-ui-icons business_briefcase-24"></i>

              <div class="col-md-10 ml-auto mr-auto">
                <div class="row collections">
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/DSC_3493.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/DSC_2986.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/DSC_3608.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/DSC_2961.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane :title="$t('landingPage.gallery.tabs.worker')">
              <i slot="label" class="now-ui-icons ui-2_settings-90"></i>

              <div class="col-md-10 ml-auto mr-auto">
                <div class="row collections">
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/IMG_1295.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/IMG_1255.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/DSC_3418.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                    <div class="gallery-img-wrap">
                      <img
                        src="img/galery/IMG_0906.jpg"
                        alt=""
                        class="img-raised"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
        <!-- <h2 class="font-weight-bold text-center" style="color: #008c45;"><i>OUR KEY TECHNOLOGIES</i></h2> -->
        <!-- <hr class="mt-n3 mb-5" style="border: 5px solid #008c45;"> -->
        <!-- <h4>Navigating the Future “Mastery Meets Innovation” </h4>

        If there is any corrosion issues, leave it to TEF. TEF contributes to safe and secure plant operations. <br>
        We will contribute to improving the production efficiency and reliability of process industries <br>
        We provide total support for corrosion challenges in the process industries. From selecting the optimal materials and cost-effective designs to high-quality <br>
        fabrication and maintenance, we ensure the reliability of your process equipment, pressure vessels, and piping. -->

        <!-- <div class="row mt-4 justify-content-center " style="font-family: Arial, sans-serif;">
          <div class="col-lg-4 ml-5">
            <h4 class="mt-n5">FUTURES</h4>
            <h3 class="font-weight-bold text-left" style="color: black;"><b>We embrace a spirit of challenge by leveraging our key strengths in</b></h3>
            <hr class="mt-n4 mb-5" style="border: 2px solid #008c45;">
            <h5 class="font-weight-bold align-middle mt-n4">Engineering Capability</h5>
            <p class="mt-n2">We delivers end-to-end engineering services from design to execution ensuring each project meets high standards of safety, precision, and efficiency.</p>
            <h5 class="font-weight-bold align-middle">Fabrication Solutions</h5>
            <p class="mt-n2">We delivers reliable fabrication services, combining skilled workmanship with quality systems to produce precise, durable components.</p>
            <h5 class="font-weight-bold align-middle">Consulting Services</h5>
            <p class="mt-n2">We provide expert consulting in engineering, fabrication planning, and operational efficiency to help clients achieve optimal project outcomes.</p>
            <h5 class="font-weight-bold align-middle">Workmanship ( Proficiency in Welding )</h5>
            <p class="mt-n2">Our certified welders are experienced in various welding techniques, delivering strong, clean, and reliable welds that meet international standards..</p>
            <h5 class="font-weight-bold align-middle">Special Materials</h5>
            <p class="mt-n2">We possess expertise in sourcing, handling, and fabricating a wide range of special materials for exceptional results.</p>
          </div>
          <div class="col-lg-6">
            <div class="section-story-overview mt-0">
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="image-container image-left mb-5"
                    style="background-image: url('img/rhodin.jpg')"
                  >
                  </div>
                  <div
                    class="mb-5"
                  ></div><br><br>
                </div>
                <div class="col-md-5">
                  <div
                    class="image-container image-right"
                    style="background-image: url('img/weld2.png')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div
      class="section section-tabs mt-n5"
      style="font-family: Arial, sans-serif"
    >
      <div class="container"></div>
      <div
        class="card"
        style="
          border-top-left-radius: 8%;
          border-top-right-radius: 8%;
          padding-bottom: -30px;
        "
      >
        <div class="container mt-5">
          <h3 class="mb-4 font-weight-bold">
            <img
              src="img/icon/icon 2 (2).png"
              alt=""
              width="4%"
              class="ml-3 mr-3"
            />
            <span style="color: #008c45">{{
              $t("landingPage.news.title")
            }}</span>
          </h3>
          <h5>{{ $t("landingPage.news.subtitle") }}</h5>
          <div class="row pt-5" v-if="table.data.length">
            <div
              class="col-lg-4 mb-4 d-flex"
              v-for="(row, i) in table.data"
              :key="i"
            >
              <router-link
                :to="/detail-blog/ + row.code"
                class="blog-card animated fadeInDown w-100"
              >
                <div class="blog-card-image">
                  <img
                    :src="storageUrl + 'banner_content/' + row.banner"
                    :alt="row.title"
                  />
                  <span class="blog-card-date">{{
                    moment(row.created_at).locale($i18n.locale).format("LL")
                  }}</span>
                </div>
                <div class="blog-card-body">
                  <h5 class="blog-card-title">{{ row.title }}</h5>
                  <p class="blog-card-excerpt">
                    {{ truncate(row.description, 130) }}
                  </p>
                  <div class="blog-card-footer">
                    <span class="blog-card-author">{{
                      $t("blog.byAdmin")
                    }}</span>
                    <span class="blog-card-readmore">
                      {{ $t("landingPage.news.readMore") }}
                      <i class="fa fa-arrow-right ml-1"></i>
                    </span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="text-center mb-5">
            <router-link to="/blog">
              <n-button
                type="default"
                size="lg"
                class="btn btn-info btn-round btn-lg align-self-center"
                style="margin-top: 0px"
              >
                <span>{{ $t("landingPage.news.moreButton") }}</span>
              </n-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-tabs text-center">
      <h3 v-html="$t('landingPage.clients.title')"></h3>
      <div
        class="card marquee-fade"
        style="
          border-top-left-radius: 8%;
          border-top-right-radius: 8%;
          padding-bottom: 70px;
        "
      >
        <div class="container-fluid mt-5">
          <marquee style="font-weight: bold; margin-top: 0px" class="mt-5">
            <!-- <img width="60%" class="mr-3" src="img/our_client/customer.png" alt="Customer logo" /> -->
            <img
              width="80"
              class="mr-5"
              src="img/our_client/asahimas.png"
              alt="Asahimas logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/mcci.png"
              alt="MCCI logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/jfe.png"
              alt="JFE logo"
            />
            <img
              width="230"
              class="mr-5"
              src="img/our_client/sulfindo.png"
              alt="Sulfindo logo"
            />
            <img
              width="140"
              class="mr-5"
              src="img/our_client/pertamina.png"
              alt="Pertamina logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/pupuk.png"
              alt="Pupuk logo"
            />
            <img
              width="60"
              class="mr-5"
              src="img/our_client/smelting.png"
              alt="Smelting logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="160"
              class="mr-5"
              src="img/our_client/sri.png"
              alt="SRI logo"
            />
            <img
              width="45"
              class="mr-5"
              src="img/our_client/statomer.png"
              alt="Statomer logo"
            />
            <img
              width="50"
              class="mr-5"
              src="img/our_client/nsi.png"
              alt="NSI logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/ineos.png"
              alt="Ineos logo"
            />
            <img
              width="50"
              class="mr-5"
              src="img/our_client/ikpt.png"
              alt="IKPT logo"
            />
            <img
              width="170"
              class="mr-5"
              src="img/our_client/lotte.png"
              alt="Lotte logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/loc.png"
              alt="LOC logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/hmm.png"
              alt="HMM logo"
            />
            <img
              width="60"
              class="mr-5"
              src="img/our_client/ajinomoto.png"
              alt="Ajinomoto logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="100"
              class="mr-5"
              src="img/our_client/chiyoda.png"
              alt="Chiyoda logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/lenzing.png"
              alt="Lenzing logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/star_energy.png"
              alt="STAR Energy logo"
            />
            <img
              width="130"
              class="mr-5"
              src="img/our_client/sankyu.png"
              alt="Sankyu logo"
            />
            <img
              width="150"
              class="mr-5"
              src="img/our_client/candra.png"
              alt="Candra logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/sumelectric.png"
              alt="Sumelectric logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/sunchirin.png"
              alt="Sunchirin logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/pfizer.png"
              alt="Pfizer logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="100"
              class="mr-5"
              src="img/our_client/basf.png"
              alt="BASF logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/kao.png"
              alt="KAO logo"
            />
            <img
              width="110"
              class="mr-5"
              src="img/our_client/toray.png"
              alt="Toray logo"
            />
            <img
              width="35"
              class="mr-5"
              src="img/our_client/tosoh.png"
              alt="Tosoh logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/idemitsu.png"
              alt="Idemitsu logo"
            />
            <img
              width="150"
              class="mr-5"
              src="img/our_client/sumchem.png"
              alt="Sumchem logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/ngk.png"
              alt="NGK logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/ak.png"
              alt="AK logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="270"
              class="mr-5"
              src="img/our_client/uic.png"
              alt="UIC logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/kureha.png"
              alt="Kureha logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/jgc_jpy.png"
              alt="JGC JPY logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/chiyoda.png"
              alt="Chiyoda logo"
            />
            <img
              width="140"
              class="mr-5"
              src="img/our_client/sekisui.png"
              alt="Sekisui logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/onex.png"
              alt="ONEX logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/jfe.png"
              alt="JFE logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="80"
              class="mr-5"
              src="img/our_client/msd.png"
              alt="MSD logo"
            />
            <img
              width="110"
              class="mr-5"
              src="img/our_client/astar.png"
              alt="Astar logo"
            />
            <img
              width="50"
              class="mr-5"
              src="img/our_client/src.png"
              alt="SRC logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/gsk.png"
              alt="GSK logo"
            />
            <img
              width="100"
              class="mr-5"
              src="img/our_client/shell.png"
              alt="Shell logo"
            />
            <img
              width="220"
              class="mr-5"
              src="img/our_client/sumcheas.png"
              alt="Sumcheas logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/oleo.png"
              alt="OLEO logo"
            />
            <img
              width="50"
              class="mr-5"
              src="img/our_client/petronas.png"
              alt="Petronas logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="50"
              class="mr-5"
              src="img/our_client/toyo.png"
              alt="TOYO logo"
            />
            <img
              width="60"
              class="mr-5"
              src="img/our_client/covestro.png"
              alt="Covestro logo"
            />
            <img
              width="120"
              class="mr-5"
              src="img/our_client/taniobis.png"
              alt="Taniobis logo"
            />
            <img
              width="60"
              class="mr-5"
              src="img/our_client/tpac.png"
              alt="TPAC logo"
            />
            <img
              width="60"
              class="mr-5"
              src="img/our_client/tpcc.png"
              alt="TPCC logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/prolific.png"
              alt="Prolific logo"
            />
            <img
              width="110"
              class="mr-5"
              src="img/our_client/kikai.png"
              alt="Kikai logo"
            />
            <img
              width="80"
              class="mr-5"
              src="img/our_client/basf_petronas.png"
              alt="BASF Petronas logo"
            />
            <img
              width="70"
              class="mr-5"
              src="img/our_client/agc.png"
              alt="AGC logo"
            />
          </marquee>
          <hr />
          <marquee>
            <img
              width="140"
              class="mr-5"
              src="img/our_client/surtec.png"
              alt="Surtec logo"
            />
            <img
              width="150"
              class="mr-5"
              src="img/our_client/scg.png"
              alt="SCG logo"
            />
            <img
              width="100"
              class="mr-5"
              src="img/our_client/toshiba.png"
              alt="Toshiba logo"
            />
            <img
              width="90"
              class="mr-5"
              src="img/our_client/jgc.png"
              alt="JGC logo"
            />
            <span class="font-weight-bold align-middle mt-5">And Others</span>
          </marquee>
        </div>
      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div
      class="page-header clear-filter moto-tokki-section"
      filter-color="purple"
      style="margin-top: -100px"
    >
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">
            {{ $t("landingPage.moto.title") }}
            <span style="font-size: 20px; color: yellow">
              {{ $t("landingPage.moto.subtitle") }}
            </span>
          </h1>
          <div class="moto-item">
            <h2 class="text-white text-left font-weight-bold">
              <span style="color: #7fff00">S</span>kill-up
            </h2>
            <h6 class="text-white text-left font-weight-bold mt-n4">
              {{ $t("landingPage.moto.skillUp.desc") }}
            </h6>
          </div>
          <div class="moto-item">
            <h2 class="text-white text-left font-weight-bold">
              <span style="color: #7fff00">T</span>imely
            </h2>
            <h6 class="text-white text-left font-weight-bold mt-n4">
              {{ $t("landingPage.moto.timely.desc") }}
            </h6>
          </div>
          <div class="moto-item">
            <h2 class="text-white text-left font-weight-bold">
              <span style="color: #7fff00">A</span>ctive
            </h2>
            <h6 class="text-white text-left font-weight-bold mt-n4">
              {{ $t("landingPage.moto.active.desc") }}
            </h6>
          </div>
          <div class="moto-item">
            <h2 class="text-white text-left font-weight-bold">
              <span style="color: #7fff00">R</span>esponsibility
            </h2>
            <h6 class="text-white text-left font-weight-bold mt-n4">
              {{ $t("landingPage.moto.responsibility.desc") }}
            </h6>
          </div>
          <div class="moto-item">
            <h2 class="text-white text-left font-weight-bold">
              <span style="color: #7fff00">T</span>ry
            </h2>
            <h6
              class="text-white text-left font-weight-bold mt-n4"
              v-html="$t('landingPage.moto.try.desc')"
            ></h6>
          </div>
        </div>
      </div>
    </div>

    <!--  <div class="section section-tabs">
      <div class="container">

      </div>
    </div> -->
  </div>
</template>
<script>
import { Carousel, CarouselItem } from "element-ui";
import { FormGroupInput, Button } from "@/components";
import { Tabs, TabPane } from "@/components";
import config from "@/configs/config";
import Api from "@/helpers/api";
var moment = require("moment");
var someVidio = require("@/assets/vidio/vidio_tef.mp4");
import visitorCounter from "@/services/visitorCounter.service";
import blog from "@/services/blog.service";

export default {
  name: "profile",
  bodyClass: "profile-page",
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    Tabs,
    TabPane,
  },
  data() {
    return {
      someVidio: someVidio + "#t=2",
      moment: moment,
      pagination: {
        page_count: "",
        default: 1,
        page: "",
      },
      onLoading: false,
      table: {
        data: [],
      },
      form: {
        add: true,
        title: "Add Data",
        show: false,
      },
      search: {
        position: "",
        level: "",
        location: "",
        requirements: "",
        status: "",
      },

      storageUrl: config.blogStorageUrl,
      loadTimeout: null,
      tokenApi: "",
    };
  },
  mounted() {
    this.tokenApi = "Bearer " + localStorage.getItem("token");
    this.getBlog();
    // this.createVisitorCounter()

    const cards = document.querySelectorAll(".scrollUp, .reveal-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      {
        threshold: 0.1,
      },
    );

    cards.forEach((scrollUp) => observer.observe(scrollUp));
  },
  methods: {
    getBlog(param) {
      let context = this;
      Api(context, blog.index())
        .onSuccess(function (response) {
          context.table.data = response.data.data.data.slice(0, 3);
        })
        .onError(function (error) {
          context.table.data = [];
        })
        .call();
    },
    truncate(str, max) {
      if (!str) return "";
      // strip HTML tags from rich-text content before truncating to plain-text excerpt
      const plain = str
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      // handle multi-byte chars safely
      const s = Array.from(plain).slice(0, max).join("");
      return s.length < plain.length ? s + "…" : s;
    },
    createVisitorCounter(param) {
      let context = this;
      Api(context, visitorCounter.createVisitorCounter())
        .onSuccess(function (response) {
          context.table.data = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
        })
        .onError(function (error) {
          if (error.response.status == 404) {
            context.table.data = [];
          }
        })
        .onFinish(function () {
          context.form.show = false;
        })
        .call();
    },
  },
};
</script>
<style>
.parallax {
  /* The image used */
  background-image: url("/img/footer_welding.jpg");
  background-indo: url("/img/banner-indonesia.jpeg");

  /* Set a specific height */
  min-height: 700px;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@property --num {
  syntax: "<integer>";
  initial-value: 0;
  inherits: false;
}

.counter {
  counter-reset: num var(--num);
  font: 800 40px system-ui;
  animation: var(--animation) 5s forwards ease-in-out;
}

.counter:after {
  content: counter(num) "+";
}

@keyframes counter-years {
  from {
    --num: 0;
  }
  to {
    --num: 3455;
  }
  /* Adjust these values as needed */
}

@keyframes counter-projects {
  from {
    --num: 0;
  }
  to {
    --num: 6;
  }
  /* Adjust these values as needed */
}

@keyframes counter-employees {
  from {
    --num: 0;
  }
  to {
    --num: 40;
  }
  /* Adjust these values as needed */
}

@keyframes counter-customers {
  from {
    --num: 0;
  }
  to {
    --num: 350;
  }
  /* Adjust these values as needed */
}

.stats-card-wrap {
  box-shadow: none;
  border-radius: 0;
}

.stats-bar {
  background: linear-gradient(120deg, #006633, #009e50);
}

.stat-item {
  color: #fff;
  padding: 16px 10px;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
  transition: transform 0.3s ease;
}

.stat-item:last-child {
  border-right: none;
}

.stat-item:hover {
  transform: translateY(-6px);
}

.stat-item h4 {
  margin: 0;
}

.stat-icon {
  font-size: 22px;
  opacity: 0.85;
  margin-bottom: 4px;
  display: block;
}

.reveal-up {
  opacity: 0;
  transform: translateY(60px);
}

.reveal-up.show {
  animation: revealUpKeyframe 0.7s ease forwards;
}

@keyframes revealUpKeyframe {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.solution-card {
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  border: none;
}

.solution-card-img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.solution-card:hover .solution-card-img {
  transform: scale(1.08);
}

.solution-card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 26px 28px 30px;
}

.solution-card-title {
  font-size: 21px;
  margin-bottom: 12px;
}

.solution-card-desc {
  font-family: Arial, sans-serif;
  flex: 1;
  margin-bottom: 18px;
  opacity: 0.95;
}

.solution-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.22);
}

.solution-readmore-link {
  text-decoration: none;
}

.solution-readmore {
  font-weight: 700;
  text-decoration: underline;
  color: #fff;
  display: inline-flex;
  align-items: center;
}

.solution-readmore i {
  transition: transform 0.3s ease;
}

.solution-card:hover .solution-readmore i {
  transform: translateX(5px);
}

.gallery-img-wrap {
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 15px;
}

.gallery-img-wrap img {
  transition: transform 0.5s ease;
}

.gallery-img-wrap:hover img {
  transform: scale(1.08);
}

.marquee-fade {
  position: relative;
}

.marquee-fade .container-fluid {
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 60px,
    #000 calc(100% - 60px),
    transparent 100%
  );
  mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 60px,
    #000 calc(100% - 60px),
    transparent 100%
  );
}

.moto-item {
  margin-bottom: 22px;
  padding-left: 16px;
  border-left: 3px solid rgba(127, 255, 0, 0.5);
}
</style>

<style>
.spacer {
  height: 100vh;
}

.slide-up {
  opacity: 0;
  transform: translateY(50px);
  animation: slideUp 0.8s ease-out forwards;
}

/* Delay animasi antar elemen */
.slide-up:nth-of-type(1) {
  animation-delay: 0.2s;
}
.slide-up:nth-of-type(2) {
  animation-delay: 0.4s;
}
.slide-up:nth-of-type(3) {
  animation-delay: 0.6s;
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<style scoped>
/*.container {
  max-width: 1200px;
  margin: 50px auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}*/

.scrollUp {
  width: 300px;
  height: 200px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.6s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.scrollUp.show {
  opacity: 1;
  transform: translateY(0);
}

.hero-bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.motoWeare {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 0 20px;
}

@media (min-width: 768px) {
  .motoWeare {
    padding: 0 40px;
  }
}

.pioneer-card {
  background: rgba(255, 255, 255, 0.38);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 36px;
  padding: 24px 26px 26px;
  max-width: 520px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
  text-align: left;
}

@media (min-width: 768px) {
  .pioneer-card {
    padding: 30px 34px 32px;
    max-width: 600px;
  }
}

.pioneer-card-title {
  color: #008c45;
  font-weight: 800;
  font-size: 22px;
  line-height: 1.35;
  margin-bottom: 14px;
}

@media (min-width: 768px) {
  .pioneer-card-title {
    font-size: 27px;
  }
}

.pioneer-card-desc {
  color: #2b2b2b;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 22px;
}

.pioneer-readmore-btn {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  background: #008c45;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 6px 6px 6px 22px;
  border-radius: 30px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.pioneer-readmore-btn:hover {
  background: #006633;
  color: #fff;
  text-decoration: none;
}

.pioneer-readmore-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #f5a623;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.moto-tokki-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
  background-color: rgb(44, 44, 44);
}

.moto-tokki-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
